import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#212121',
        secondary: '#313131',
        tertiary: '#2a2a2a',
        anchor: colors.cyan.lighten3, // Link colors
      },
    },
    options: {
      customProperties: true,
    }
  },
});
